import { Breadcrumbs, H3 } from '@blueprintjs/core';
import { SITE_PAGES } from 'Config';
import PropTypes from 'prop-types';
import { useLayoutEffect, useRef, useState } from 'react';
import styles from './AppContentView.module.css';

const AppContentView = ({
  title = undefined,
  titleButton,
  breadcrumbs = [],
  children,
  hideBreadcrumbs = false,
  header,
  footer,
  noPadding = false,
}) => {
  let allBreadcrumbs = [SITE_PAGES.HOME, ...breadcrumbs];
  const scrollDiv = useRef(null);
  const [hasScrollBar, setHasScrollBar] = useState(false);

  useLayoutEffect(() => {
    if (!titleButton) return;

    const { current } = scrollDiv;
    const trigger = () => {
      const hasOverflow = current.scrollHeight > current.clientHeight;
      setHasScrollBar(hasOverflow);
    };

    if (current) {
      new ResizeObserver(trigger).observe(current);
      trigger();
    }
  }, [scrollDiv]);

  let titleContent = title && (
    <div
      style={{
        display: 'flex',
        padding: '12px 0 0 24px',
        alignItems: 'flex-start',
      }}>
      <H3
        style={{
          display: 'inline-flex',
          marginBottom: 0,
          alignItems: 'center',
        }}>
        {title}
      </H3>
      {titleButton && (
        <div
          style={{
            marginLeft: 'auto',
            marginRight: hasScrollBar ? 34 : 20,
            position: 'relative',
            top: 12,
          }}>
          {titleButton}
        </div>
      )}
    </div>
  );

  return (
    <>
      {header || !hideBreadcrumbs || titleContent ? (
        <div className={styles.header_box}>
          {header}
          {!hideBreadcrumbs && (
            <div className={styles.bread_crumb_box}>
              <Breadcrumbs
                className={styles.bread_crumb}
                items={allBreadcrumbs}
              />
            </div>
          )}
          {titleContent}
        </div>
      ) : (
        <div className={styles.dummy_box}></div>
      )}

      <div
        ref={scrollDiv}
        className={
          noPadding ? styles.content_no_padding : styles.scrollable_content
        }
        id={'app_content_container'}>
        {children}
      </div>

      <div className={styles.footer_content} id={'app_footer_container'}>
        {footer}
      </div>
    </>
  );
};

AppContentView.propTypes = {
  title: PropTypes.node,
  titleContent: PropTypes.node,
  titleButton: PropTypes.node,
  breadcrumbs: PropTypes.array,
  children: PropTypes.node,
  hideBreadcrumbs: PropTypes.bool,
  header: PropTypes.element,
  noScroll: PropTypes.bool,
  footer: PropTypes.element,
  noPadding: PropTypes.bool,
};

export default AppContentView;
